import StepIdentification from '@/febos/chile/dnt/components/wizard/companies/61808000-5/external/StepIdentification';
import StepInformation from '@/febos/chile/dnt/components/wizard/companies/61808000-5/external/StepInformation';
import StepFiles from '@/febos/chile/dnt/components/wizard/companies/61808000-5/external/StepFiles';
import ProvidencesMap from '@/febos/chile/dnt/mixins/ProvidencesMap';
import authors from '@/febos/chile/dnt/components/wizard/companies/61808000-5/utils/Authors';

export default () => ({
  currentStep: 0,
  steps: [
    {
      title: 'Identificación',
      component: StepIdentification
    },
    {
      title: 'Información',
      component: StepInformation
    },
    {
      title: 'Documentos relacionados',
      component: StepFiles
    }
  ],
  options: ['submit', 'draft'],
  submitAction: 'saveDocument',
  backupAction: 'saveDocument',
  loadAllData: true,
  wizardMapper(
    {
      dnt,
      observaciones,
      destinatarios,
      adjuntos,
      referencias,
      etiquetas,
      metadata
    }
  ) {
    const data = {};

    if (dnt) {
      data.fileNumber = dnt.numero;
      data.documentType = dnt.emisorCentroCostoNumero;
      data.document = dnt.emisorSucursalCodigo;
      data.documentNumber = dnt.numeroInt;
      if (dnt.fechaEmision) {
        data.issueDate = dnt.fechaEmision;
      }
      if (dnt.fechaEntrega) {
        data.issueDateMother = dnt.fechaEntrega;
      }
      if (dnt.fechaVencimiento) {
        data.expirationDate = dnt.fechaVencimiento;
      }
      if (dnt.despachoCodigo) {
        try {
          data.author = authors.find((value) => value.value === dnt.despachoCodigo);
        } catch (e) {
          console.log(e);
        }
      }
      data.isMother = dnt.estadoCodigoEstadoComprador;
      data.isPrivate = dnt.transportePuertoTipo || '0';
      data.resumen = dnt.nombreDescriptivo;
      data.institutionType = dnt.compradorCodigo;
      data.institutionTypeName = dnt.compradorArea;
      data.institution = dnt.emisorContactoCodigo;
      data.institutionName = dnt.emisorContactoArea;
      data.personName = dnt.emisorContactoNombre;
      data.personPosition = dnt.emisorContactoCargo;
      data.personEmail = dnt.emisorContactoEmail;
      data.personPhone = dnt.emisorContactoTelefono;
      data.withAttachment = dnt.transporteViaTransporteCodigoTransporte;
      data.documentDetail = dnt.transporteNotas;
      data.creatorGroup = dnt.solicitanteGrupoId;
      data.documentNumberMother = dnt.transporteEmbalajeTara;
      data.asunto = dnt.pasajeAereo;
      data.theme = dnt.transporteEmpresaTransporteInfoAdicional;
      data.subTheme = dnt.estadoDescripcionEstadoComprador;
      data.requiereResponse = dnt.receptorTelefono || '1';
    }

    if (dnt.solicitanteDocumentoId) {
      data.solicitanteRut = dnt.solicitanteRut;
      data.solicitanteNombre = dnt.solicitanteNombre;
      data.solicitanteEmail = dnt.solicitanteEmail;
      data.solicitanteDocumentoId = dnt.solicitanteDocumentoId;
    }

    if (observaciones && observaciones.length) {
      data.matter = observaciones[0].observacion;
      if (observaciones[1]) {
        data.observation = observaciones[1].observacion;
      }
    }

    if (destinatarios && destinatarios.length) {
      const subjects = destinatarios
        .filter((subject) => subject.tipoDestino.toString() === '1'
          && subject.estado.toString() === '1')
        .map((subject) => {
          const subjectTypeDigitalDoc = subject.institucionCodigo
            ? {
              id: subject.institucionCodigoId,
              value: subject.institucionCodigo,
              label: subject.institucionNombre
            }
            : {};

          return {
            subjectType: {
              id: subject.destinoCodigoId,
              value: subject.destinoCodigo,
              label: subject.destinoNombre
            },
            subject: {
              id: subject.destinoListaCodigoId,
              value: subject.destinoListaCodigo,
              label: subject.destinoListaNombre
            },
            subjectEmail: subject.destinoCorreo,
            status: subject.estado,
            providence: subject.providenciaId || '',
            providenceExpiration: subject.providenciaVencimiento || '',
            dntDestinatariosId: subject.dntDestinatariosId,
            subjectTypeDigitalDoc
          };
        });

      data.subjects = [...subjects];
      data.subjectsSelected = [...subjects];

      const copies = destinatarios
        .filter((subject) => subject.tipoDestino.toString() === '2')
        .map((subject) => {
          const copySubjectTypeDigitalDoc = subject.institucionCodigo
            ? {
              id: subject.institucionCodigoId,
              value: subject.institucionCodigo,
              label: subject.institucionNombre
            }
            : {};

          return {
            copySubjectType: {
              id: subject.destinoCodigoId,
              value: subject.destinoCodigo,
              label: subject.destinoNombre
            },
            copySubject: {
              id: subject.destinoListaCodigoId,
              value: subject.destinoListaCodigo,
              label: subject.destinoListaNombre
            },
            copySubjectEmail: subject.destinoCorreo,
            providence: subject.providenciaId || '',
            providenceExpiration: subject.providenciaVencimiento || '',
            dntDestinatariosId: subject.dntDestinatariosId,
            status: subject.estado,
            copySubjectTypeDigitalDoc
          };
        });

      data.copies = [...copies];
      data.copiesSelected = [...copies];
      data.metadata = (metadata || []).map((item) => ({
        name: item.nombre,
        value: item.valor
      }));
    }

    if (adjuntos && adjuntos.length) {
      const main = adjuntos
        .find((file) => file.tipo === 'principal');

      if (main) {
        data.mainFile = {
          id: main.adjuntoId || main.id,
          type: main.tipo,
          mime: main.adjuntoMime,
          name: main.adjuntoNombre,
          path: main.adjuntoUrl,
          date: main.fecha
        };
      }

      data.additionalFiles = adjuntos
        .filter((file) => file.tipo === 'adjunto' || file.tipo === 'respuesta')
        .map((file) => ({
          id: file.adjuntoId || main.id,
          type: file.tipo,
          mime: file.adjuntoMime,
          name: file.adjuntoNombre,
          path: file.adjuntoUrl,
          date: file.fecha
        }));
    }

    if (referencias && referencias.length) {
      const referenceMother = referencias.find((relatedDocument) => relatedDocument.codigo === 'mother');
      const referencesDoc = referencias.filter((ref) => ref.codigo !== 'mother');
      const relatedDocuments = referencesDoc.map((relatedDocument) => ({
        id: relatedDocument.linea,
        type: relatedDocument.tipoDocumento,
        number: relatedDocument.folio
      }));
      data.references = referenceMother;
      data.relatedDocuments = [...relatedDocuments];
      data.relatedDocumentsSelected = [...relatedDocuments];
    }

    if (etiquetas && etiquetas.length) {
      data.tags = etiquetas.map((tag) => ({ text: tag.etiqueta }));
    }

    return data;
  },
  documentMapper(input, iutCompany, nameCompany, isDraft = false) {
    const data = {
      adjuntos: [],
      dnt: {
        tipo: 'EXP',
        emisorRut: iutCompany,
        receptorRut: iutCompany,
        emisorRazonSocial: nameCompany,
        receptorRazonSocial: nameCompany,
        claseMercadoPublico: 'ext',
        estado: 1,
        emisorCentroCostoNumero: input.documentType,
        emisorCentroCostoNombre: input.documentTypeName,
        emisorSucursalCodigo: input.document,
        emisorSucursalDireccion: input.documentName,
        numeroInt: input.documentNumber,
        transportePuertoTipo: '0',
        nombreDescriptivo: input.resumen,
        solicitanteGrupoId: input.creatorGroup,
        solicitanteGrupoNombre: input.creatorGroupName,
        compradorCodigo: input.institutionType,
        compradorArea: input.institutionTypeName,
        emisorContactoCodigo: input.institution,
        emisorContactoArea: input.institutionName,
        emisorContactoNombre: input.personName,
        emisorSucursalCiudad: input.documentOptId,
        emisorSucursalPais: input.documentTypeId,
        emisorContactoCargo: input.personPosition,
        emisorContactoEmail: input.personEmail,
        emisorContactoTelefono: input.personPhone,
        transporteViaTransporteCodigoTransporte: input.withAttachment,
        transporteNotas: input.documentDetail,
        estadoCodigoEstadoComprador: input.isMother,
        transporteEmbalajeTara: input.documentNumberMother,
        pasajeAereo: input.asunto,
        transporteEmpresaTransporteInfoAdicional: input.theme,
        estadoDescripcionEstadoComprador: input.subTheme,
        receptorTelefono: input.requiereResponse || '0',
      },
      etiquetas: (input.tags || []).map((tag) => ({
        etiqueta: tag.text
      })),
      destinatarios: [
        ...(input.subjectsSelected || []).map((subject) => {
          const institution = Object.keys(subject.subjectTypeDigitalDoc).length
            ? {
              institucionCodigoId: subject.subjectTypeDigitalDoc.id,
              institucionCodigo: subject.subjectTypeDigitalDoc.value,
              institucionNombre: subject.subjectTypeDigitalDoc.label,
            }
            : {};

          return {
            tipoDestino: 1,
            estado: 1,
            destinoCodigoId: subject.subjectType.id,
            destinoCodigo: subject.subjectType.value,
            destinoNombre: subject.subjectType.label,
            destinoListaCodigoId: subject.subject.id,
            destinoListaCodigo: subject.subject.value,
            destinoListaNombre: subject.subject.label,
            destinoCorreo: subject.subjectEmail,
            providenciaId: subject.providence,
            providenciaVencimiento: subject.providenceExpiration,
            ...institution
          };
        }),
        ...(input.copiesSelected || []).map((subject) => {
          const institution = Object.keys(subject.copySubjectTypeDigitalDoc).length
            ? {
              institucionCodigoId: subject.copySubjectTypeDigitalDoc.id,
              institucionCodigo: subject.copySubjectTypeDigitalDoc.value,
              institucionNombre: subject.copySubjectTypeDigitalDoc.label,
            }
            : {};

          return {
            tipoDestino: 2,
            estado: 1,
            destinoCodigoId: subject.copySubjectType.id,
            destinoCodigo: subject.copySubjectType.value,
            destinoNombre: subject.copySubjectType.label,
            destinoListaCodigoId: subject.copySubject.id,
            destinoListaCodigo: subject.copySubject.value,
            destinoListaNombre: subject.copySubject.label,
            destinoCorreo: subject.copySubjectEmail,
            providenciaId: subject.providence,
            providenciaVencimiento: subject.providenceExpiration,
            ...institution
          };
        })
      ],
      referencias: (input.relatedDocumentsSelected || []).map((relatedDocument) => ({
        linea: relatedDocument.id,
        tipoDocumento: relatedDocument.type,
        folio: relatedDocument.number
      })),
      metadata: [
        { nombre: 'form_name', tipo: 1, valor: 'FORM_ING_REGULACIO' },
        { nombre: 'DOCNAME', tipo: 1, valor: input.documentNumber },
        { nombre: 'DOCUMENTO_MADRE', tipo: 1, valor: input.documentNumberMother },
        { nombre: 'EMPRESA_ID', tipo: 1, valor: input.idCompany },
        { nombre: 'TYPE_ID', tipo: 1, valor: input.documentType },
        { nombre: 'ID', tipo: 1, valor: input.author?.value },
        { nombre: 'ID_AUTOR', tipo: 1, valor: input.institutionType },
        { nombre: 'ID_TEMA', tipo: 1, valor: input.theme },
        { nombre: 'ID_SUBTEMA', tipo: 1, valor: input.subTheme },
        { nombre: 'MATERIA_REG', tipo: 1, valor: input.matter },
        { nombre: 'DOCUMENTO_ADJUNTO', tipo: 1, valor: input.document },
        { nombre: 'USE_ID', tipo: 1, valor: input.idUser },
        { nombre: 'DOC_RELACIONADO', tipo: 2, valor: JSON.stringify(input.relatedDocumentsSelected) },
        { nombre: 'CAMPO45', tipo: 1, valor: input.issueDate },
        {
          nombre: 'ACCION',
          tipo: 2,
          valor: JSON.stringify((input.subjectsSelected || []).map(
            (subjectSelected) => ProvidencesMap[subjectSelected.providence]
          ))
        },
        {
          nombre: 'ACCION_ID',
          tipo: 2,
          valor: JSON.stringify((input.subjectsSelected || []).map(
            (subjectSelected) => subjectSelected.providence
          ))
        }
      ]
    };
    if (input.metadata?.some((item) => item.name === 'DOCNUM')) {
      const metaDocNum = input.metadata?.find((item) => item.name === 'DOCNUM');
      if (metaDocNum.value) {
        data.metadata.push({
          nombre: metaDocNum.name,
          tipo: 1,
          valor: metaDocNum.value
        });
      }
    }
    data.dnt.fechaEmision = input.issueDate || null;

    if (input.issueDateMother) {
      data.dnt.fechaEntrega = input.issueDateMother;
    }

    data.dnt.fechaVencimiento = input.expirationDate || null;

    if (input.author) {
      data.dnt.despachoCodigo = input.author.value;
    }

    if (input.solicitanteDocumentoId) {
      data.dnt.solicitanteRut = input.solicitanteRut;
      data.dnt.solicitanteNombre = input.solicitanteNombre;
      data.dnt.solicitanteEmail = input.solicitanteEmail;
      data.dnt.solicitanteDocumentoId = input.solicitanteDocumentoId;
    }

    if (input.matter) {
      data.observaciones = [
        {
          linea: '0',
          observacion: input.matter
        }
      ];
    }

    if (input.observation) {
      data.observaciones.push({
        linea: '1',
        observacion: input.observation
      });
    }

    if (input.mainFile) {
      data.adjuntos = [
        ...data.adjuntos,
        {
          adjuntoId: input.mainFile.id,
          tipo: 'principal',
          adjuntoMime: input.mainFile.mime,
          adjuntoNombre: input.mainFile.name,
          fecha: input.mainFile.date,
          adjuntoUrl: input.mainFile.path
        }
      ];
    }

    if (input.additionalFiles && input.additionalFiles.length) {
      data.adjuntos = [
        ...data.adjuntos,
        ...(input.additionalFiles || []).map((file) => ({
          tipo: 'adjunto',
          adjuntoId: file.id,
          adjuntoMime: file.mime,
          adjuntoNombre: file.name,
          fecha: file.date,
          adjuntoUrl: file.path
        }))
      ];
    }

    if (isDraft) {
      data.dnt.estado = 3;
    }
    // eslint-disable-next-line
    if (!parseInt(input.isMother) && input.references && input.references.folio) {
      data.referencias.push(input.references);
    }

    localStorage.setItem('sender', JSON.stringify({
      name: input.personName,
      position: input.personPosition
    }));

    return data;
  }
});
